import { render } from "./YourAccs.vue?vue&type=template&id=0309c229&scoped=true&ts=true"
import script from "./YourAccs.vue?vue&type=script&lang=ts"
export * from "./YourAccs.vue?vue&type=script&lang=ts"

import "./YourAccs.vue?vue&type=style&index=0&id=0309c229&lang=scss&scoped=true"

import exportComponent from "/home/vaab/dev/js/monujo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0309c229"]])

export default __exports__